'use strict';

var $ = require('jquery');

var $window = $(window);

/**
 * @description Workaround to check video controls and poster and set it if default init failed
 */
function reInitVideoUI() {
    $window.on('load', function () {
        var $videos = $('.video');
        var $videoCtr;

        var showPlayButton = function ($videoCtr) {
            $videoCtr.find('button').not('.footer-newsletter .button, .unvisible').show();
        };

        var hidePlayButton = function ($videoCtr) {
            $videoCtr.find('button').hide();
        };

        var setPoster = function ($videoCtr) {
            var videoID;
            var posterSrc;
            var $vjsPoster;

            // check if video is video.js
            if ($videoCtr && $videoCtr.children('div').data('setup')) {
                videoID = $videoCtr.children('div').data('setup').sources
                    ? $videoCtr.children('div').data('setup').sources[0].src
                    : null;

                if (videoID !== null) {
                    videoID = videoID.substring(videoID.indexOf('v=') + 2);
                    posterSrc = 'https://img.youtube.com/vi/' + videoID + '/maxresdefault.jpg';

                    // set poster
                    if (posterSrc !== null) {
                        $vjsPoster = $videoCtr.find('.vjs-poster');
                        $vjsPoster.css('background-image', 'url(' + posterSrc + ')');
                        $vjsPoster.removeClass('vjs-hidden');
                    }
                }
            }
        };

        $videos.each(function () {
            $videoCtr = $(this);

            showPlayButton($videoCtr);
            setPoster($videoCtr);

            $videoCtr.children('div').on('click touchstart', function () {
                var $vjsCtr = $(this);
                var checkTimer;
                var counter = 0;

                checkTimer = setInterval(function () {
                    if ($vjsCtr.hasClass('vjs-ended')) {
                        clearInterval(checkTimer);
                        setPoster($videoCtr);
                    } else if (counter == 10) {
                        clearInterval(checkTimer);
                    }
                    counter += 1;
                }, 200);
            });
        });

        if ($('.video .video-js').length === 0) {
            $('.magazine-video .video-default .heading-1').hide();
        }
    });
}

module.exports = function () {
    reInitVideoUI();
};
